

















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class DialogDeleteSubscriptionConfirm extends Vue {
  confimDialog = false
  message = ''

  mounted(){
    this.message = ''
  }

  onDelete() {
    this.$emit('confirmed', this.message)
    this.confimDialog = false
  }
}
